import React from 'react';
import { Lightbulb } from 'lucide-react';
import { Card, CardContent } from '@roger/ui-components';

const Dashboard: React.FC = () => {
  return (
    <div className='space-y-6'>
      <div className='flex justify-between items-center'>
        <div>
          <h1 className='text-2xl font-bold tracking-tight'>Dashboard</h1>
        </div>
      </div>

      {/* Guide/Disclaimer Content */}
      <div className='space-y-6'>
        <Card className='border-amber-200 bg-amber-50/50'>
          <CardContent className='p-6'>
            <div className='flex items-start gap-4'>
              <Lightbulb className='h-6 w-6 text-amber-600 mt-1 flex-shrink-0' />
              <div>
                <h3 className='text-md font-semibold text-amber-900 mb-2'>
                  Getting Started
                </h3>
                <p className='text-amber-800'>
                  Use the navigation menu to explore different sections of the
                  system.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Dashboard;
